var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffective1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3794 3.63037C36.3248 10.977 40.4019 18.7819 45 26.3221",
    stroke: "#FF5800",
    strokeWidth: 4.7868,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65547 3C18.1922 11.7239 28.9558 21.8406 39.0292 32.187",
    stroke: "#FF5800",
    strokeWidth: 4.7868,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 27.9393C12.8039 29.4849 25.8317 35.9036 35.3049 39.8803",
    stroke: "#FF5800",
    strokeWidth: 4.7868,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffective1);
export default __webpack_public_path__ + "static/media/effective1.f935e8055a51ea15e1ef5df5ba48ec04.svg";
export { ForwardRef as ReactComponent };